module.exports = __webpack_public_path__ + "img/person.bc3e2336.png";